import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import CardOrder from '../../main/order-grid/cardOrder';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme, withStyles } from '@material-ui/core/styles';
import moment from 'moment';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
    </MuiDialogTitle>
  );
});

function OrderDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const { orders } = props

  if (!orders || !orders.length) {
    return null;
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open}
      maxWidth={'90%'}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Bestellung</DialogTitle>
      <DialogContent>
      <div style={{ justifyContent: 'center', width: '100%', display: 'flex', marginBottom: 10, overflowX: 'scroll' }}>
        {
          orders && orders.length
          ? orders.map(o => 
            (
              <div style={{ marginRight: 10 }} key={`order_dialog_order_${o.id}`}>
                {
                  o.pickupTimeNumeric && moment(o.pickupTimeNumeric).endOf('day').isAfter(moment().endOf('day')) ?
                  (<p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center', fontSize: 20 }}>Achtung Abholtag liegt in der Zukunft</p>) 
                  : null
                }
                <CardOrder
                  value={o}
                  localSettings={props.localSettings || {}}
                  proceedOrder={props.proceedOrder}
                />
              </div>
            )
          )          
          : null
        }
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={props.onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}

OrderDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  order: PropTypes.object,
  orders: PropTypes.array,
  onClose: PropTypes.func,
};

OrderDialog.defaultProps = {
  order: null,
  orders: null,
  onDismiss: () => { },
  onClose: () => { },
};

export default OrderDialog;
